<div class="z-50 relative" aria-labelledby="modal-title" role="dialog" aria-modal="true"> <!-- relative -->
  <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>

  <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
    <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
      <div class="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl 
        transition-all sm:my-8 w-full max-w-screen-sm">
        <div class="">
          <ng-container [ngSwitch]="profileContainerId">
            <!-- Profile Settings -->
            <ng-container *ngSwitchCase="'User Profile'" [ngTemplateOutlet]="userProfileTemplate"></ng-container>

            <!-- Security Settings -->
            <ng-container *ngSwitchCase="'Security'" [ngTemplateOutlet]="securityTemplate"></ng-container>

            <!-- Change Password -->
            <ng-container *ngSwitchCase="'Change Password'" [ngTemplateOutlet]="changePasswordTemplate"></ng-container>

            <!-- Multi Factor Auth -->
            <ng-container *ngSwitchCase="'MFA Setup'" [ngTemplateOutlet]="multiFactorAuthTemplate"></ng-container>

            <!-- Authenticator App -->
            <ng-container *ngSwitchCase="'Authenticator'" [ngTemplateOutlet]="authenticatorAppTemplate"></ng-container>

            <!-- SMS -->
            <ng-container *ngSwitchCase="'SMS'" [ngTemplateOutlet]="smsSetupTemplate"></ng-container>

            <!-- Email -->
            <ng-container *ngSwitchCase="'EMAIL'" [ngTemplateOutlet]="emailSetupTemplate"></ng-container>

            <!-- Recovery Codes -->
            <ng-container *ngSwitchCase="'Recovery Codes'" [ngTemplateOutlet]="recoveryCodeTemplate"></ng-container>

            <!-- Verify OTP -->
            <ng-container *ngSwitchCase="'OTP'" [ngTemplateOutlet]="verifyOtpTemplate"></ng-container>

            <!-- Default -->
            <ng-container *ngSwitchDefault [ngTemplateOutlet]="userProfileTemplate"></ng-container>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- User Profile -->
<ng-template #userProfileTemplate>
  <div class="h-36 w-full" [style.background]="'url(\'/assets/images/png/profile_banner.png\')'">
    <button type="button"
      class="absolute right-2.5 top-3 bg-gray-800 rounded-full opacity-50 hover:opacity-75 p-1 text-indigo-200 hover:text-white focus:outline-none focus:ring-white"
      [mat-dialog-close]="{status: false}">
      <svg class="h-5 w-5 text-white" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
        aria-hidden="true">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"></path>
      </svg>
    </button>
  </div>

  <div class="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8">
    <div class="-mt-12 sm:flex sm:items-end sm:space-x-5">
      <div class="relative">
        <img class="h-30 w-30 rounded-full ring-4 ring-white" [src]="user?.profile_picture" alt="">
        <div class="h-30 w-30 bg-gray-800 opacity-0 hover:opacity-75 absolute top-0 rounded-full"
          (click)="onProfileImageClick()" *ngIf="editProfileSettings">
          <div class="h-30 flex items-center justify-center">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="h-8 w-8 text-white">
              <path d="M12 9a3.75 3.75 0 1 0 0 7.5A3.75 3.75 0 0 0 12 9Z" />
              <path fill-rule="evenodd"
                d="M9.344 3.071a49.52 49.52 0 0 1 5.312 0c.967.052 1.83.585 2.332 1.39l.821 1.317c.24.383.645.643 1.11.71.386.054.77.113 1.152.177 1.432.239 2.429 1.493 2.429 2.909V18a3 3 0 0 1-3 3h-15a3 3 0 0 1-3-3V9.574c0-1.416.997-2.67 2.429-2.909.382-.064.766-.123 1.151-.178a1.56 1.56 0 0 0 1.11-.71l.822-1.315a2.942 2.942 0 0 1 2.332-1.39ZM6.75 12.75a5.25 5.25 0 1 1 10.5 0 5.25 5.25 0 0 1-10.5 0Zm12-1.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
                clip-rule="evenodd" />
            </svg>
          </div>
        </div>
        <input #imageInput type="file" id="profile_photo_input" accept="image/*"
          style="visibility:hidden; position: absolute; left: -5000px;" (change)="onImageSelected($event)">
      </div>

      <div>
        <h1 class="w-56 text-2xl font-bold text-gray-900 truncate" [matTooltip]="fullUsername"
          [matTooltipDisabled]="fullUsername.length <= 20" matTooltipPosition="above">
          {{fullUsername}}
        </h1>
        <p class="text-secondary text-base">{{user.email}}</p>
      </div>

      <div class="mt-6 sm:flex sm:min-w-0 sm:flex-1 sm:items-center sm:justify-end sm:space-x-6 sm:pb-1">
        <div class="mt-6 flex flex-col justify-stretch space-y-3 sm:flex-row sm:space-x-4 sm:space-y-0">

          <button type="button" (click)="onEditProfileClick()" *ngIf="!editProfileSettings"
            class="inline-flex justify-center gap-x-1.5 rounded-md bg-white text-gray-800 border-none px-3 py-2 text-md font-medium shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
              stroke="currentColor" class="-ml-0.5 h-5 w-5 text-gray-800">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10" />
            </svg>
            {{'text.edit_profile' | translate}}
          </button>

          <button type="button" (click)="openProfileContainer('Security')" *ngIf="!editProfileSettings"
            class="inline-flex justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-md font-medium text-gray-800 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
              stroke="currentColor" class="-ml-0.5 h-5 w-5 text-gray-800">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M7.864 4.243A7.5 7.5 0 0 1 19.5 10.5c0 2.92-.556 5.709-1.568 8.268M5.742 6.364A7.465 7.465 0 0 0 4.5 10.5a7.464 7.464 0 0 1-1.15 3.993m1.989 3.559A11.209 11.209 0 0 0 8.25 10.5a3.75 3.75 0 1 1 7.5 0c0 .527-.021 1.049-.064 1.565M12 10.5a14.94 14.94 0 0 1-3.6 9.75m6.633-4.596a18.666 18.666 0 0 1-2.485 5.33" />
            </svg>
            {{'text.security' | translate}}
          </button>

        </div>
      </div>
    </div>

    <!-- Profile Info -->
    <ng-container *ngIf="!editProfileSettings">
      <div class=" my-4 mb-6 block">
        <div class="flex flex-col space-y-8 pt-6">

          <div class="flex sm:items-center">
            <mat-icon role="img" class="mat-icon notranslate mat-icon-no-color" aria-hidden="true"
              data-mat-icon-type="svg" data-mat-icon-name="briefcase" data-mat-icon-namespace="heroicons_outline">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor" aria-hidden="true" fit="" height="100%" width="100%"
                preserveAspectRatio="xMidYMid meet" focusable="false">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M20.25 14.15v4.25c0 1.094-.787 2.036-1.872 2.18-2.087.277-4.216.42-6.378.42s-4.291-.143-6.378-.42c-1.085-.144-1.872-1.086-1.872-2.18v-4.25m16.5 0a2.18 2.18 0 00.75-1.661V8.706c0-1.081-.768-2.015-1.837-2.175a48.114 48.114 0 00-3.413-.387m4.5 8.006c-.194.165-.42.295-.673.38A23.978 23.978 0 0112 15.75c-2.648 0-5.195-.429-7.577-1.22a2.016 2.016 0 01-.673-.38m0 0A2.18 2.18 0 013 12.489V8.706c0-1.081.768-2.015 1.837-2.175a48.111 48.111 0 013.413-.387m7.5 0V5.25A2.25 2.25 0 0013.5 3h-3a2.25 2.25 0 00-2.25 2.25v.894m7.5 0a48.667 48.667 0 00-7.5 0M12 12.75h.008v.008H12v-.008z">
                </path>
              </svg>
            </mat-icon>
            <div class="ml-6 leading-6"> {{user.designation || '---'}} </div>
          </div>

          <div class="flex" *ngIf="(user.mobile_phone_number || user.work_phone_number)">
            <mat-icon role="img" class="mat-icon notranslate mat-icon-no-color" aria-hidden="true"
              data-mat-icon-type="svg" data-mat-icon-name="phone" data-mat-icon-namespace="heroicons_outline">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor" aria-hidden="true" fit="" height="100%" width="100%"
                preserveAspectRatio="xMidYMid meet" focusable="false">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z">
                </path>
              </svg>
            </mat-icon>
            <div class="ml-6 min-w-0 space-y-1">
              <div class="flex items-center leading-6" *ngIf="user.mobile_phone_number">
                <div class="font-mono"> {{user.mobile_phone_number ?? '---'}} </div>
                <div class="text-secondary truncate text-md"><span class="mx-2">•</span>
                  <span class="font-medium"> {{'text.mobile' | translate }} </span>
                </div>
              </div>
              <div class="flex items-center leading-6" *ngIf="user.work_phone_number">
                <div class="font-mono"> {{user.work_phone_number ?? '---'}} </div>
                <div class="text-secondary truncate text-md"><span class="mx-2">•</span>
                  <span class="font-medium"> {{'text.work' | translate }} </span>
                </div>
              </div>
            </div>
          </div>

          <div class="flex sm:items-center">
            <mat-icon role="img" class="mat-icon notranslate mat-icon-no-color" aria-hidden="true"
              data-mat-icon-type="svg" data-mat-icon-name="map-pin" data-mat-icon-namespace="heroicons_outline">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
              </svg>
            </mat-icon>
            <div class="ml-6 leading-6"> {{userPreferences.timezone || '---'}} </div>
          </div>

          <div class="flex sm:items-center">
            <mat-icon role="img" class="mat-icon notranslate mat-icon-no-color" aria-hidden="true"
              data-mat-icon-type="svg" data-mat-icon-name="cake" data-mat-icon-namespace="heroicons_outline">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor" class="size-6">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="m10.5 21 5.25-11.25L21 21m-9-3h7.5M3 5.621a48.474 48.474 0 0 1 6-.371m0 0c1.12 0 2.233.038 3.334.114M9 5.25V3m3.334 2.364C11.176 10.658 7.69 15.08 3 17.502m9.334-12.138c.896.061 1.785.147 2.666.257m-4.589 8.495a18.023 18.023 0 0 1-3.827-5.802" />
              </svg>
            </mat-icon>
            <div class="ml-6 leading-6"> {{userPreferedLanguage ?? '---'}} </div>
          </div>

        </div>
      </div>
    </ng-container>
    <!-- End Profile Info-->

    <!-- Edit Profile -->
    <ng-container *ngIf="editProfileSettings">
      <div class="h-90 mt-8">
        <nav class="flex space-x-4" aria-label="Tabs">
          <a (click)="switchTab('profile')" [ngClass]="selectedTab === 'profile' ? 'bg-product-light product': ''"
            class="rounded-md px-5 py-2 text-base font-medium cursor-pointer hover:bg-red-100" aria-current="page">
            {{ 'text.my_profile' | translate }}
          </a>
          <a (click)="switchTab('preferences')"
            [ngClass]="selectedTab === 'preferences' ? 'bg-product-light product': ''"
            class="rounded-md px-5 py-2 text-base font-medium cursor-pointer hover:bg-red-100">
            {{ 'calendar.preferences' | translate }}
          </a>
        </nav>

        <!-- User Profile -->
        <ng-container *ngIf="selectedTab === 'profile'">
          <div class="my-6 block">
            <form [formGroup]="userProfileForm" autocomplete="false">
              <div class="text-base grid grid-cols-3 items-start sm:gap-4 space-x-3 sm:py-4">
                <label for="first-name" class="block text-base font-medium leading-8 text-gray-900">
                  {{'name.text' | translate}} <span class="text-red-500"> *</span>
                </label>

                <div class="mt-2 sm:col-span-1 sm:mt-0">
                  <input type="text" name="first-name" id="first-name" autocomplete="given-name"
                    formControlName="first_name"
                    class="block w-full rounded-md border-0 px-3 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:max-w-xs sm:leading-6"
                    placeholder="{{'text.first_name' | translate}}">

                  <p class="text-red-500 text-base mt-1"
                    *ngIf="userProfileForm.controls.first_name?.errors?.required && userProfileForm.controls.first_name.touched">
                    {{'text.field_is_required'| translate}}
                  </p>
                </div>

                <div class="mt-2 sm:col-span-1 sm:mt-0">
                  <input type="text" name="last-name" id="last-name" autocomplete="last-name"
                    formControlName="last_name"
                    class="block w-full rounded-md border-0 px-3 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:max-w-xs sm:leading-6"
                    placeholder="{{'text.last_name' | translate}}">

                  <p class="text-red-500 text-base mt-1"
                    *ngIf="userProfileForm.controls.last_name?.errors?.required && userProfileForm.controls.last_name.touched">
                    {{'text.field_is_required'| translate}}
                  </p>
                </div>
              </div>

              <div class="text-base grid grid-cols-3 items-start sm:gap-4 space-x-3 sm:py-4">
                <label for="email" class="block text-base font-medium leading-8 text-gray-900">
                  {{ 'email' | translate }} <span class="text-red-500"> *</span>
                </label>

                <div class="mt-2 sm:col-span-2 sm:mt-0">
                  <input type="email" name="email" id="email" autocomplete="email" formControlName="email"
                    class="block w-full rounded-md border-0 px-3 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:leading-6"
                    placeholder="Eg: yourname@email.com">

                  <p class="text-red-500 text-base mt-1"
                    *ngIf="userProfileForm.controls.email?.errors?.required && userProfileForm.controls.email.touched">
                    {{'text.field_is_required'| translate}}
                  </p>
                  <p class="text-red-500 text-base mt-1" *ngIf="userProfileForm.controls.email?.errors?.email">
                    {{'text.invalid_email_address'| translate}}
                  </p>
                </div>
              </div>

              <div class="text-base grid grid-cols-3 items-start sm:gap-4 space-x-3 sm:py-4">
                <label for="email" class="block text-base font-medium leading-8 text-gray-900">
                  {{'users.table.designation' | translate}} <span class="text-red-500"> *</span>
                </label>

                <div class="mt-2 sm:col-span-2 sm:mt-0">
                  <input type="text" name="designation" id="designation" autocomplete="designation"
                    formControlName="designation"
                    class="block w-full rounded-md border-0 px-3 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:leading-6"
                    placeholder="Eg: Service Manager">

                  <p class="text-red-500 text-base mt-1"
                    *ngIf="userProfileForm.controls.designation?.errors?.required && userProfileForm.controls.designation.touched">
                    {{'text.field_is_required'| translate}}
                  </p>
                </div>
              </div>

              <div class="text-base grid grid-cols-3 items-start sm:gap-4 space-x-3 sm:py-4">
                <label for="work-number" class="block text-base font-medium leading-8 text-gray-900">
                  {{'text.mobile' | translate}} / {{'text.work' | translate}} {{'forms.label.number' | translate}}
                </label>

                <div class="mt-2 sm:col-span-1 sm:mt-0">
                  <input type="text" name="mobile-number" id="mobile-number" autocomplete="mobile-number"
                    formControlName="mobile_phone_number"
                    class="block w-full rounded-md border-0 px-3 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:max-w-xs sm:leading-6"
                    placeholder="{{'text.mobile_number' | translate}}">

                  <p class="text-red-500 text-base mt-1"
                    *ngIf="userProfileForm.controls.mobile_phone_number?.errors?.required && userProfileForm.controls.mobile_phone_number.touched">
                    {{'text.field_is_required'| translate}}
                  </p>
                </div>

                <div class="mt-2 sm:col-span-1 sm:mt-0">
                  <input type="text" name="work-number" id="work-number" autocomplete="work-number"
                    formControlName="work_phone_number"
                    class="block w-full rounded-md border-0 px-3 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:max-w-xs sm:leading-6"
                    placeholder="{{'text.work_number' | translate}}">

                  <p class="text-red-500 text-base mt-1"
                    *ngIf="userProfileForm.controls.work_phone_number?.errors?.required && userProfileForm.controls.work_phone_number.touched">
                    {{'text.field_is_required'| translate}}
                  </p>
                </div>
              </div>
            </form>
          </div>
        </ng-container>

        <!-- User Preferences -->
        <ng-container *ngIf="selectedTab === 'preferences'">
          <div class="my-6 block">
            <form [formGroup]="userPreferencesForm" autocomplete="false">

              <div class="text-base grid grid-cols-3 items-start sm:gap-4 space-x-3 sm:py-4">
                <label for="time-format" class="block text-base font-medium leading-8 text-gray-900">
                  {{'text.timezone' | translate}} <span class="text-red-500"> *</span>
                </label>

                <div class="mt-2 sm:col-span-2 sm:mt-0">
                  <ng-select [items]="timezoneList" bindLabel="display_name" bindValue="key" dropdownPosition="auto"
                    labelForId="timezone"
                    placeholder="{{'users.table.select' | translate}} {{'text.timezone' | translate}}"
                    [virtualScroll]="true" formControlName="timezone" appendTo="body">
                  </ng-select>

                  <p class="text-red-500 text-base mt-1"
                    *ngIf="userPreferencesForm.controls.timezone?.errors?.required && userPreferencesForm.controls.timezone.touched">
                    {{'text.field_is_required'| translate}}
                  </p>
                </div>
              </div>

              <div class="text-base grid grid-cols-3 items-start sm:gap-4 space-x-3 sm:py-4">
                <label for="user_language" class="block text-base font-medium leading-8 text-gray-900">
                  {{'text.language' | translate}} <span class="text-red-500"> *</span>
                </label>

                <div class="mt-2 sm:col-span-2 sm:mt-0">
                  <select formControlName="language" id="user_language"
                    class="block bg-white w-full rounded-md border-0 px-3 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:leading-6">
                    <option disabled>{{'text.select_language' | translate}}</option>
                    <ng-container *ngFor="let language of supportedLanguages">
                      <option [value]="language.value">{{language.label}}</option>
                    </ng-container>
                  </select>

                  <p class="text-red-500 text-base mt-1"
                    *ngIf="userPreferencesForm.controls.language?.errors?.required && userPreferencesForm.controls.language.touched">
                    {{'text.field_is_required'| translate}}
                  </p>
                </div>
              </div>

              <div class="text-base grid grid-cols-3 items-start sm:gap-4 space-x-3 sm:py-4">
                <label for="date-format" class="block text-base font-medium leading-8 text-gray-900">
                  {{'text.date' | translate}} {{'text.format' | translate}} <span class="text-red-500"> *</span>
                </label>

                <div class="mt-2 sm:col-span-2 sm:mt-0">
                  <select formControlName="date_format"
                    class="block bg-white w-full rounded-md border-0 px-3 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:leading-6">
                    <option disabled>{{'text.choose_date_format' | translate}}</option>
                    <option value="DD/MM/YYYY">DD/MM/YYYY (Eg: 12/03/2018)</option>
                    <option value="MM/DD/YYYY">MM/DD/YYYY (Eg: 03/12/2018)</option>
                    <option value="YYYY/MM/DD">YYYY/MM/DD (Eg: 2018/03/12)</option>
                  </select>

                  <p class="text-red-500 text-base mt-1"
                    *ngIf="userPreferencesForm.controls.date_format?.errors?.required && userPreferencesForm.controls.date_format.touched">
                    {{'text.field_is_required'| translate}}
                  </p>
                </div>
              </div>

              <div class="text-base grid grid-cols-3 items-start sm:gap-4 space-x-3 sm:py-4">
                <label for="time-format" class="block text-base font-medium leading-8 text-gray-900">
                  {{'text.time' | translate}} {{'text.format' | translate}} <span class="text-red-500"> *</span>
                </label>

                <div class="mt-2 sm:col-span-2 sm:mt-0">
                  <select formControlName="time_format"
                    class="block bg-white w-full rounded-md border-0 px-3 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:leading-6">
                    <option disabled>{{'text.choose_time_format' | translate}}</option>
                    <option value="12_HRS">12 Hour Format (Eg: 07:00 PM)</option>
                    <option value="24_HRS">24 Hour Format (Eg: 19:00 Hrs)</option>
                  </select>

                  <p class="text-red-500 text-base mt-1"
                    *ngIf="userPreferencesForm.controls.time_format?.errors?.required && userPreferencesForm.controls.time_format.touched">
                    {{'text.field_is_required'| translate}}
                  </p>
                </div>
              </div>

            </form>
          </div>
        </ng-container>
      </div>

      <div class="border-t py-4 sm:flex sm:flex-row-reverse">
        <button type="button" (click)="onProfileUpdateClick()" [disabled]="disableUpdateButton"
          [ngClass]="{'opacity-30 cursor-not-allowed submitBtn': disableUpdateButton}"
          class="inline-flex w-full justify-center rounded-md bg-product px-5 py-2 text-base text-white shadow-sm sm:ml-3 sm:w-auto">
          {{ 'update' | translate }}
        </button>

        <button type="button" (click)="onCancelClick()"
          class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-5 py-2 text-base  text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto">
          {{ 'cancel.text'| translate }}
        </button>
      </div>
    </ng-container>
    <!-- End Edit Profile -->
  </div>
</ng-template>

<!-- Security -->
<ng-template #securityTemplate>
  <div class="flex justify-between items-center border-b border-b-gray-300 zuper-dialog-header">
    <h2 class="text-xl font-semibold leading-6 text-gray-900 inline-flex items-center" id="slide-over-title">
      <button (click)="openProfileContainer('User Profile')" class="h-10 w-10 p-2 mr-2 rounded-full hover:bg-gray-200">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
          stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" />
        </svg>
      </button>
      {{'text.security_settings' | translate}}
    </h2>
    <div class="flex items-center mr-1">
      <button mat-dialog-close
        class="rounded-full flex justify-center items-center hover:bg-gray-200 h-10 w-10 p-2 ml-2">
        <em class="ti ti-x text-xl font-bold"></em>
      </button>
    </div>
  </div>

  <!-- Security Settings Menu -->
  <div class="mx-auto max-w-4xl px-5">
    <ul role="list" class="divide-y divide-gray-100">

      <li class="relative flex justify-between gap-x-6 py-5" (click)="openProfileContainer('Change Password')">
        <div class="flex min-w-0 gap-x-4 cursor-pointer">
          <img class="h-12 w-12 flex-none bg-gray-50" src="/assets/images/svgs/sso.svg" alt="">
          <div class="min-w-0 flex-auto">
            <p class="text-lg font-semibold leading-6 text-gray-900">
              <span class="absolute inset-x-0 -top-px bottom-0"></span>
              {{'password.text' | translate}}
            </p>
            <p class="mt-1 flex text-base leading-5 text-gray-500">
              <span class="truncate">{{'text.change_password_info' | translate}}</span>
            </p>
          </div>
        </div>
        <div class="flex shrink-0 items-center gap-x-2">
          <div class="hidden sm:flex sm:flex-col sm:items-end">
            <p class="text-base leading-6 text-gray-500">{{'users.home.actions.change_password' | translate}}</p>
          </div>
          <svg class="h-5 w-5 flex-none text-gray-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path fill-rule="evenodd"
              d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z"
              clip-rule="evenodd"></path>
          </svg>
        </div>
      </li>

      <li class="relative flex justify-between gap-x-6 py-5" (click)="openProfileContainer('MFA Setup')"
        *ngIf="is2faEnabled">
        <div class="flex min-w-0 gap-x-4 cursor-pointer">
          <img class="h-12 w-12 flex-none bg-gray-50" src="/assets/images/svgs/multi_factor_auth.svg" alt="">
          <div class="min-w-0 flex-auto">
            <p class="text-lg font-semibold leading-6 text-gray-900">
              <span class="absolute inset-x-0 -top-px bottom-0"></span>
              {{'text.multi_factor_auth' | translate}}
            </p>
            <p class="mt-1 flex text-base leading-5 text-gray-500">
              <span class="truncate">{{'text.multi_factor_auth_info' | translate}}</span>
            </p>
          </div>
        </div>
        <div class="flex shrink-0 items-center gap-x-2">
          <div class="hidden sm:flex sm:flex-col sm:items-end">
            <p class="text-base leading-6 text-gray-500">{{'text.configure_2fa' | translate}}</p>

          </div>
          <svg class="h-5 w-5 flex-none text-gray-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path fill-rule="evenodd"
              d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z"
              clip-rule="evenodd"></path>
          </svg>
        </div>
      </li>

      <li class="relative flex justify-between gap-x-6 py-5" (click)="onUserLogoutClick()">
        <div class="flex min-w-0 gap-x-4 cursor-pointer">
          <img class="h-12 w-12 flex-none bg-gray-50" src="/assets/images/svgs/password_policy.svg" alt="">
          <div class="min-w-0 flex-auto">
            <p class="text-lg font-semibold leading-6 text-gray-900">
              <span class="absolute inset-x-0 -top-px bottom-0"></span>
              {{'text.logout_all_sessions' | translate}}
            </p>
            <p class="mt-1 flex text-base leading-5 text-gray-500">
              <span class="truncate">{{'text.logout_all_sessions_info' | translate}}</span>
            </p>
          </div>
        </div>
        <div class="flex shrink-0 items-center gap-x-2">
          <div class="hidden sm:flex sm:flex-col sm:items-end">
            <p class="text-base leading-6 text-gray-500">{{'text.logout' | translate}}</p>

          </div>
          <svg class="h-5 w-5 flex-none text-gray-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path fill-rule="evenodd"
              d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z"
              clip-rule="evenodd"></path>
          </svg>
        </div>
      </li>

    </ul>
  </div>
</ng-template>

<!-- Change Password Template -->
<ng-template #changePasswordTemplate>
  <div class="flex justify-between items-center border-b border-b-gray-300 zuper-dialog-header">
    <h2 class="text-xl font-semibold leading-6 text-gray-900 inline-flex items-center" id="slide-over-title">
      <button (click)="openProfileContainer('Security'); cancelChangePassword()"
        class="h-10 w-10 p-2 mr-2 rounded-full hover:bg-gray-200">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
          stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" />
        </svg>
      </button>
      {{'text.change_new_password' | translate}}
    </h2>
    <div class="flex items-center mr-1">
      <button mat-dialog-close
        class="rounded-full flex justify-center items-center hover:bg-gray-200 h-10 w-10 p-2 ml-2">
        <em class="ti ti-x text-xl font-bold"></em>
      </button>
    </div>
  </div>

  <form [formGroup]="changePasswordForm" autocomplete="off">

    <div class="px-5 mb-3 block text-base">
      <!-- Current Password -->
      <div class="py-2">
        <div class="relative">
          <label for="current_password" class="block text-base font-normal leading-8 text-gray-800">
            {{'text.label.change_password' | translate}}
          </label>

          <input type="password" id="current_password"
            class="block w-full rounded-md border-0 px-3 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:leading-6"
            placeholder="{{'placeholder.current_password' | translate}}" formControlName="currentPassword"
            #currentPasswordField>

          <button type="button" id="toggleCurrentPassword"
            class="absolute top-11 right-4 text-gray-500 hover:text-gray-700"
            (click)="currentPasswordField.type === 'password' ? currentPasswordField.type = 'text' : currentPasswordField.type = 'password'">

            <span class="icon-size-5" *ngIf="currentPasswordField.type === 'text'">
              <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-eye" width="44" height="44"
                viewBox="0 0 24 24" stroke-width="1.5" stroke="#2c3e50" fill="none" stroke-linecap="round"
                stroke-linejoin="round">
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" />
                <path d="M21 12c-2.4 4 -5.4 6 -9 6c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6" />
              </svg>
            </span>

            <span class="icon-size-5" *ngIf="currentPasswordField.type === 'password'">
              <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-eye-off" width="44"
                height="44" viewBox="0 0 24 24" stroke-width="1.5" stroke="#2c3e50" fill="none" stroke-linecap="round"
                stroke-linejoin="round">
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M10.585 10.587a2 2 0 0 0 2.829 2.828" />
                <path d="M16.681 16.673a8.717 8.717 0 0 1 -4.681 1.327c-3.6 0 -6.6 -2 -9 -6c1.272 -2.12 2.712 -3.678 4.32 -4.674m2.86 -1.146a9.055 
                9.055 0 0 1 1.82 -.18c3.6 0 6.6 2 9 6c-.666 1.11 -1.379 2.067 -2.138 2.87" />
                <path d="M3 3l18 18" />
              </svg>
            </span>
          </button>

          <p *ngIf="(changePasswordForm.controls.currentPassword.touched && changePasswordForm.get('currentPassword').errors)"
            class="text-red-500 text-base mt-1">
            {{'text.field_is_required'| translate}}
          </p>
        </div>
      </div>

      <!-- New Password -->
      <div class="py-2">
        <div class="relative">
          <label for="new_password" class="block text-base font-normal leading-8 text-gray-800">
            {{'text.label.new_password' | translate}}
          </label>

          <input type="password" id="new_password"
            class="block w-full rounded-md border-0 px-3 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:leading-6"
            placeholder="{{'placeholder.new_password' | translate}}" formControlName="newPassword" #newPasswordField>

          <button type="button" id="toggleNewPassword" class="absolute top-11 right-4 text-gray-500 hover:text-gray-700"
            (click)="newPasswordField.type === 'password' ? newPasswordField.type = 'text' : newPasswordField.type = 'password'">

            <span class="icon-size-5" *ngIf="newPasswordField.type === 'text'">
              <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-eye" width="44" height="44"
                viewBox="0 0 24 24" stroke-width="1.5" stroke="#2c3e50" fill="none" stroke-linecap="round"
                stroke-linejoin="round">
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" />
                <path d="M21 12c-2.4 4 -5.4 6 -9 6c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6" />
              </svg>
            </span>

            <span class="icon-size-5" *ngIf="newPasswordField.type === 'password'">
              <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-eye-off" width="44"
                height="44" viewBox="0 0 24 24" stroke-width="1.5" stroke="#2c3e50" fill="none" stroke-linecap="round"
                stroke-linejoin="round">
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M10.585 10.587a2 2 0 0 0 2.829 2.828" />
                <path d="M16.681 16.673a8.717 8.717 0 0 1 -4.681 1.327c-3.6 0 -6.6 -2 -9 -6c1.272 -2.12 2.712 -3.678 4.32 -4.674m2.86 -1.146a9.055 
                9.055 0 0 1 1.82 -.18c3.6 0 6.6 2 9 6c-.666 1.11 -1.379 2.067 -2.138 2.87" />
                <path d="M3 3l18 18" />
              </svg>
            </span>
          </button>

          <p *ngIf="(changePasswordForm.controls.newPassword.touched && changePasswordForm.get('newPassword').errors)"
            class="text-red-500 text-base mt-1">
            <span *ngIf="(changePasswordForm.get('newPassword').errors.required || 
                changePasswordForm.get('newPassword').errors.minLength)">
              {{'change.password.new_password.required.message' | translate}}
            </span>
          </p>
        </div>
      </div>

      <!-- Confirm Password -->
      <div class="py-2">
        <div class="relative">
          <label for="confirm_password" class="block text-base font-normal leading-8 text-gray-800">
            {{'text.label.confirm_new_password' | translate}}
          </label>

          <input type="password" id="confirm_password"
            class="block w-full rounded-md border-0 px-3 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:leading-6"
            placeholder="{{'placeholder.confirm_password' | translate}}" formControlName="confirmPassword"
            #confirmPasswordField>

          <button type="button" id="toggleConfirmPassword"
            class="absolute top-11 right-4 text-gray-500 hover:text-gray-700"
            (click)="confirmPasswordField.type === 'password' ? confirmPasswordField.type = 'text' : confirmPasswordField.type = 'password'">

            <span class="icon-size-5" *ngIf="confirmPasswordField.type === 'text'">
              <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-eye" width="44" height="44"
                viewBox="0 0 24 24" stroke-width="1.5" stroke="#2c3e50" fill="none" stroke-linecap="round"
                stroke-linejoin="round">
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" />
                <path d="M21 12c-2.4 4 -5.4 6 -9 6c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6" />
              </svg>
            </span>

            <span class="icon-size-5" *ngIf="confirmPasswordField.type === 'password'">
              <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-eye-off" width="44"
                height="44" viewBox="0 0 24 24" stroke-width="1.5" stroke="#2c3e50" fill="none" stroke-linecap="round"
                stroke-linejoin="round">
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M10.585 10.587a2 2 0 0 0 2.829 2.828" />
                <path d="M16.681 16.673a8.717 8.717 0 0 1 -4.681 1.327c-3.6 0 -6.6 -2 -9 -6c1.272 -2.12 2.712 -3.678 4.32 -4.674m2.86 -1.146a9.055 
                9.055 0 0 1 1.82 -.18c3.6 0 6.6 2 9 6c-.666 1.11 -1.379 2.067 -2.138 2.87" />
                <path d="M3 3l18 18" />
              </svg>
            </span>
          </button>

          <p *ngIf="(changePasswordForm.controls.confirmPassword.touched && changePasswordForm.get('confirmPassword').errors)"
            class="text-red-500 text-base mt-1">
            <span *ngIf="(changePasswordForm.get('confirmPassword').errors.required || 
                changePasswordForm.get('confirmPassword').errors.minLength)">
              {{'change.password.confirm_password.required.message' | translate}}
            </span>
            <span *ngIf="(changePasswordForm.get('confirmPassword').errors.confirmPasswordValidator)">
              {{'change.password.confirm_password.match.message' | translate}}
            </span>
          </p>
        </div>
      </div>

    </div>
  </form>

  <div class="border-t px-4 py-4 sm:flex sm:flex-row-reverse sm:px-6">
    <button type="button" (click)="onChangePasswordUpdateClick()" [disabled]="disableUpdateButton"
      [ngClass]="{'opacity-30 cursor-not-allowed submitBtn': disableUpdateButton}" class="inline-flex w-full justify-center rounded-md bg-product px-5 py-2 text-base 
        text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto">
      {{ 'update' | translate }}
    </button>

    <button type="button" (click)="openProfileContainer('Security'); cancelChangePassword()" class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-5 py-2 text-base
         text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto">
      {{ 'cancel.text'| translate }}
    </button>
  </div>
</ng-template>

<!-- Multi Factor Authentication Menu Template -->
<ng-template #multiFactorAuthTemplate>
  <div class="flex justify-between items-center border-b border-b-gray-300 zuper-dialog-header">
    <h2 class="text-xl font-semibold leading-6 text-gray-900 inline-flex items-center" id="slide-over-title">
      <button (click)="openProfileContainer('Security')" class="h-10 w-10 p-2 mr-2 rounded-full hover:bg-gray-200">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
          stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" />
        </svg>
      </button>
      {{'text.multi_factor_auth' | translate}}
    </h2>
    <div class="flex items-center mr-1">
      <button mat-dialog-close
        class="rounded-full flex justify-center items-center hover:bg-gray-200 h-10 w-10 p-2 ml-2">
        <em class="ti ti-x text-xl font-bold"></em>
      </button>
    </div>
  </div>

  <div class="mx-auto max-w-4xl px-5">
    <ul role="list" class="divide-y divide-gray-100">

      <!-- Authenticator App Setup Menu -->
      <li class="relative flex justify-between gap-x-6 py-5" (click)="showAuthAppSetup();">
        <div class="flex min-w-0 gap-x-4 cursor-pointer">
          <div class="h-12 w-12 flex items-center justify-center bg-product-light product rounded-lg">
            <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-asterisk h-6 w-6" width="44"
              height="44" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" fill="none"
              stroke-linecap="round" stroke-linejoin="round">
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M12 12l8 -4.5" />
              <path d="M12 12v9" />
              <path d="M12 12l-8 -4.5" />
              <path d="M12 12l8 4.5" />
              <path d="M12 3v9" />
              <path d="M12 12l-8 4.5" />
            </svg>
          </div>
          <div class="min-w-0 flex-auto">
            <p class="text-lg font-semibold leading-6 text-gray-900">
              <span class="absolute inset-x-0 -top-px bottom-0"></span>
              {{'text.2fa.authenticator_app' | translate}}
            </p>
            <p class="mt-1 flex text-base leading-5 text-gray-500">
              <span class="truncate">{{'text.2fa.authenticator_app_info' | translate}}</span>
            </p>
            <ng-container *ngIf="(check2FAForVerify('TOTP') || check2FAForRemove('TOTP'))">
              <p class="mt-1 flex text-sm leading-5 text-gray-500">
                {{ 'text.2fa.setup_initiated_on' | translate }} {{ get2FASetupDate('TOTP') | datetime }}
              </p>
            </ng-container>
          </div>
        </div>

        <div class="flex shrink-0 items-center gap-x-2">
          <div class="hidden sm:flex sm:flex-col sm:items-end">
            <p class="text-base leading-6 text-gray-500">
              {{show2FAStatus('TOTP') | translate}}
            </p>
          </div>
          <svg class="h-5 w-5 flex-none text-gray-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path fill-rule="evenodd"
              d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z"
              clip-rule="evenodd"></path>
          </svg>
        </div>
      </li>

      <!-- SMS Setup Menu -->
      <li class="relative flex justify-between gap-x-6 py-5" (click)="show2FASetup('SMS')">
        <div class="flex min-w-0 gap-x-4 cursor-pointer">
          <div class="h-12 w-12 flex items-center justify-center bg-product-light product rounded-lg">
            <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-message h-6 w-6" width="44"
              height="44" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" fill="none"
              stroke-linecap="round" stroke-linejoin="round">
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M8 9h8" />
              <path d="M8 13h6" />
              <path d="M18 4a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-5l-5 3v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12z" />
            </svg>
          </div>
          <div class="min-w-0 flex-auto">
            <p class="text-lg font-semibold leading-6 text-gray-900">
              <span class="absolute inset-x-0 -top-px bottom-0"></span>
              {{'text.2fa.text_or_sms' | translate}}
            </p>
            <p class="mt-1 flex text-base leading-5 text-gray-500">
              <span class="truncate">{{'text.2fa.text_or_sms_info' | translate}}</span>
            </p>
            <ng-container *ngIf="(check2FAForVerify('SMS') || check2FAForRemove('SMS'))">
              <p class="mt-1 flex text-sm leading-5 text-gray-500">
                {{ 'text.2fa.setup_initiated_on' | translate}} {{ get2FASetupDate('SMS') | datetime }}
              </p>
            </ng-container>
          </div>
        </div>

        <div class="flex shrink-0 items-center gap-x-2">
          <div class="hidden sm:flex sm:flex-col sm:items-end">
            <p class="text-base leading-6 text-gray-500">
              {{show2FAStatus('SMS') | translate}}
            </p>

          </div>
          <svg class="h-5 w-5 flex-none text-gray-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path fill-rule="evenodd"
              d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z"
              clip-rule="evenodd"></path>
          </svg>
        </div>
      </li>

      <!-- Email Setup Menu -->
      <li class="relative flex justify-between gap-x-6 py-5" (click)="show2FASetup('EMAIL')">
        <div class="flex min-w-0 gap-x-4 cursor-pointer">
          <div class="h-12 w-12 flex items-center justify-center bg-product-light product rounded-lg">
            <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-mail h-6 w-6" width="44"
              height="44" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" fill="none"
              stroke-linecap="round" stroke-linejoin="round">
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M3 7a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-10z" />
              <path d="M3 7l9 6l9 -6" />
            </svg>
          </div>
          <div class="min-w-0 flex-auto">
            <p class="text-lg font-semibold leading-6 text-gray-900">
              <span class="absolute inset-x-0 -top-px bottom-0"></span>
              {{'email' | translate}}
            </p>
            <p class="mt-1 flex text-base leading-5 text-gray-500">
              <span class="truncate">{{'text.2fa.email_info' | translate}}</span>
            </p>
            <ng-container *ngIf="(check2FAForVerify('EMAIL') || check2FAForRemove('EMAIL'))">
              <p class="mt-1 flex item-center text-sm leading-5 text-gray-500">
                {{ 'text.2fa.setup_initiated_on' | translate}} {{ get2FASetupDate('EMAIL') | datetime }}
              </p>
            </ng-container>
          </div>
        </div>

        <div class="flex shrink-0 items-center gap-x-2">
          <div class="hidden sm:flex sm:flex-col sm:items-end">
            <p class="text-base leading-6 text-gray-500">
              {{show2FAStatus('EMAIL') | translate}}
            </p>
          </div>
          <svg class="h-5 w-5 flex-none text-gray-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path fill-rule="evenodd"
              d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z"
              clip-rule="evenodd"></path>
          </svg>
        </div>
      </li>

      <!-- Recovery Code Setup Menu -->
      <li class="relative flex justify-between gap-x-6 py-5" (click)="showRecoveryCodeSetup()">
        <div class="flex min-w-0 gap-x-4 cursor-pointer">
          <div class="h-12 w-12 flex items-center justify-center bg-product-light product rounded-lg">
            <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-key h-6 w-6" width="44"
              height="44" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" fill="none"
              stroke-linecap="round" stroke-linejoin="round">
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path
                d="M16.555 3.843l3.602 3.602a2.877 2.877 0 0 1 0 4.069l-2.643 2.643a2.877 2.877 0 0 1 -4.069 0l-.301 -.301l-6.558 6.558a2 2 0 0 1 -1.239 .578l-.175 .008h-1.172a1 1 0 0 1 -.993 -.883l-.007 -.117v-1.172a2 2 0 0 1 .467 -1.284l.119 -.13l.414 -.414h2v-2h2v-2l2.144 -2.144l-.301 -.301a2.877 2.877 0 0 1 0 -4.069l2.643 -2.643a2.877 2.877 0 0 1 4.069 0z" />
              <path d="M15 9h.01" />
            </svg>
          </div>
          <div class="min-w-0 flex-auto">
            <p class="text-lg font-semibold leading-6 text-gray-900">
              <span class="absolute inset-x-0 -top-px bottom-0"></span>
              {{'text.2fa.recovery_codes' | translate}}
            </p>
            <p class="mt-1 flex text-base leading-5 text-gray-500">
              {{ 'text.recovery_code_info' | translate }}
            </p>
            <ng-container *ngIf="recoveryCodes.length">
              <p class="mt-1 flex item-center text-sm leading-5 text-gray-500">
                <span class="truncate">{{'text.generated' | translate}}
                  {{recoveryCodeDetails?.generatedDate | dateAgo}}
                </span>
              </p>
            </ng-container>
          </div>
        </div>

        <div class="flex shrink-0 items-center gap-x-2">
          <div class="hidden sm:flex sm:flex-col sm:items-end">
            <p class="text-base leading-6 text-gray-500">
              <span *ngIf="!recoveryCodes.length">{{'text.generate' | translate}}</span>
              <span *ngIf="recoveryCodes.length">{{"overall_search.recently_viewed.view" | translate}}</span>
            </p>
          </div>
          <svg class="h-5 w-5 flex-none text-gray-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path fill-rule="evenodd"
              d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z"
              clip-rule="evenodd"></path>
          </svg>
        </div>
      </li>

    </ul>
  </div>
</ng-template>

<!-- Authenticator App Template -->
<ng-template #authenticatorAppTemplate>
  <div class="flex justify-between items-center border-b border-b-gray-300 zuper-dialog-header">
    <h2 class="text-xl font-semibold leading-6 text-gray-900 inline-flex items-center" id="slide-over-title">
      <button (click)="cancelAuthAppSetup()" class="h-10 w-10 p-2 mr-2 rounded-full hover:bg-gray-200">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
          stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" />
        </svg>
      </button>
      {{'text.2fa.authenticator_app' | translate}}
    </h2>
    <div class="flex items-center mr-1">
      <button mat-dialog-close
        class="rounded-full flex justify-center items-center hover:bg-gray-200 h-10 w-10 p-2 ml-2">
        <em class="ti ti-x text-xl font-bold"></em>
      </button>
    </div>
  </div>

  <div class="mx-auto max-w-4xl px-5">
    <div class="flow-root">
      <ul role="list" class="my-6">
        <li>
          <div class="relative pb-8">
            <span class="absolute left-4 top-4 -ml-px h-full w-0.5 bg-gray-200" aria-hidden="true"></span>
            <div class="relative flex space-x-3">
              <div>
                <span class="flex h-8 w-8 items-center justify-center rounded-full bg-gray-200 ring-8 ring-white">
                  <span class="text-lg">1</span>
                </span>
              </div>
              <div class="flex min-w-0 flex-1 justify-between space-x-4">
                <div class="text-base">
                  <h5 class="text-gray-800 text-lg font-medium">{{'text.download_authenticator_app' | translate}}</h5>
                  <p class="text-gray-500">{{'text.download_authenticator_app_info' | translate}}</p>
                </div>
              </div>
            </div>
          </div>
        </li>

        <li>
          <div class="relative pb-8">
            <span class="absolute left-4 top-4 -ml-px h-full w-0.5 bg-gray-200" aria-hidden="true"></span>
            <div class="relative flex space-x-3">
              <div>
                <span class="flex h-8 w-8 items-center justify-center rounded-full bg-gray-200 ring-8 ring-white">
                  <span class="text-lg">2</span>
                </span>
              </div>
              <div class="flex min-w-0 flex-1 justify-between space-x-4">
                <div class="text-base">
                  <h5 class="text-gray-800 text-lg font-medium">{{'text.scan_qr_code' | translate}}</h5>
                  <p class="text-gray-500">{{'text.scan_qr_code_info' | translate}}</p>
                  <div class="mt-2 p-1 border rounded-md h-48 w-48">
                    <img [src]="authenticatorAppSetupConfig?.qr_image" alt="2FA_QR_Code">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>

        <li>
          <div class="relative pb-8">
            <span class="absolute left-4 top-4 -ml-px h-full w-0.5 bg-gray-200" aria-hidden="true"></span>
            <div class="relative flex space-x-3">
              <div>
                <span class="flex h-8 w-8 items-center justify-center rounded-full bg-gray-200 ring-8 ring-white">
                  <span class="text-lg">3</span>
                </span>
              </div>
              <div class="flex min-w-0 flex-1 justify-between space-x-4">
                <div class="text-base">
                  <h5 class="text-gray-800 text-lg font-medium">{{'text.enter_otp_code' | translate}}</h5>
                  <p class="text-gray-500">{{'text.enter_otp_code_info' | translate}}</p>
                  <div class="mt-2">
                    <ng-otp-input [config]="{length:6, disableAutoFocus: true, allowNumbersOnly: true}"
                      [formCtrl]="otpFormControl"></ng-otp-input>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>

  <div class="flex justify-between border-gray-300 border-t zuper-dialog-footer">
    <div class="remove-btn-section">
      <button type="button" (click)="showRemoveAuthAlert('TOTP')" *ngIf="check2FAForRemove('TOTP')"
        class="px-6 flex items-center py-2 border shadow-sm text-white bg-red-600 text-base font-medium rounded-md btn-small">
        {{'text.remove' | translate}}
      </button>
    </div>

    <div class="add-btn-section">
      <button type="button" (click)="cancelAuthAppSetup()"
        class="ml-auto inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none mr-2">
        {{ 'cancel.text'| translate }}
      </button>

      <button type="button" (click)="verifyOtp('TOTP')" [disabled]="disableUpdateButton"
        [ngClass]="{'opacity-30 cursor-not-allowed submitBtn': disableUpdateButton}"
        class="inline-flex items-center px-4 py-2 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-primary hover:bg-primary-700 focus:outline-none">
        {{ 'update' | translate }}
      </button>
    </div>
  </div>
</ng-template>

<!-- Text/SMS Setup Template -->
<ng-template #smsSetupTemplate>
  <div class="h-full profile-card-height">
    <div class="flex justify-between items-center border-b border-b-gray-300 zuper-dialog-header">
      <h2 class="text-xl font-semibold leading-6 text-gray-900 inline-flex items-center" id="slide-over-title">
        <button (click)="cancelSMSSetup()"
          class="h-10 w-10 p-2 mr-2 rounded-full hover:bg-gray-200">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" />
          </svg>
        </button>
        {{'text.sms_setup' | translate}}
      </h2>
      <div class="flex items-center mr-1">
        <button mat-dialog-close
          class="rounded-full flex justify-center items-center hover:bg-gray-200 h-10 w-10 p-2 ml-2">
          <em class="ti ti-x text-xl font-bold"></em>
        </button>
      </div>
    </div>

    <div class="max-w-4xl px-5 py-2 card-content-height">
      <div class="flex min-w-0 flex-1 justify-between space-x-4">
        <div class="text-base">
          <p class="text-gray-500">{{'text.2fa.mobile_setup' | translate}}</p>
        </div>
      </div>

      <div class="flow-root mt-2">
        <ul role="list" class="my-4">
          <li>
            <div class="relative pb-8">
              <span class="absolute left-4 top-4 -ml-px h-full w-0.5 bg-gray-200" aria-hidden="true"></span>
              <div class="relative flex space-x-3">
                <div>
                  <span class="flex h-8 w-8 items-center justify-center rounded-full bg-gray-200 ring-8 ring-white">
                    <span class="text-lg">1</span>
                  </span>
                </div>
                <div class="flex flex-1 justify-between space-x-4">
                  <div class="text-base w-full">
                    <h5 class="text-gray-800 text-lg font-medium">{{'text.mobile_number' | translate}}</h5>
                    <p class="text-gray-500">{{'text.provide_mobile_number' | translate}}</p>

                    <div class="mt-2">
                      <div class="flex"
                        [ngClass]="{'cursor-not-allowed pointer-events-none opacity-50': isOtpSentToUser}">
                        <span
                          class="inline-flex items-center align-middle px-3 py-2 text-md text-gray-900 border border-r-0 rounded-r-none border-gray-300 rounded-md"
                          [matMenuTriggerFor]="dropdown">

                          <span class="flex items-center">
                            <span class="w-6 h-4 overflow-hidden"
                              [style.background]="'url(\'/assets/images/png/flags.png\') no-repeat 0 0'"
                              [style.backgroundSize]="'24px 3876px'"
                              [style.backgroundPosition]="selectedCountry.flagImagePos"></span>
                            <span class="text-lg mx-2"> {{selectedCountry.code}} </span>
                          </span>

                          <em class="ti ti-chevron-down text-base font-semibold ml-2"></em>

                          <mat-menu #dropdown="matMenu" class="markup-menu">
                            <ng-container *ngFor="let country of countries; trackBy: trackByFn">
                              <div (click)="changeCountryCode(country)">
                                <a mat-menu-item class="h-10">
                                  <span class="flex items-center">
                                    <span class="w-6 h-4 overflow-hidden"
                                      [style.background]="'url(\'/assets/images/png/flags.png\') no-repeat 0 0'"
                                      [style.backgroundSize]="'24px 3876px'"
                                      [style.backgroundPosition]="country.flagImagePos"></span>
                                    <span class="ml-2">{{country.name}}</span>
                                    <span class="ml-2 font-medium">{{country.code}}</span>
                                  </span>
                                </a>
                              </div>
                            </ng-container>
                          </mat-menu>
                        </span>

                        <input type="text" name="phone_input" id="phone_input" placeholder="123-456-7890"
                          autocomplete="off" [formControl]="mobileNumberFormControl"
                          class="block w-full rounded-md border-0 px-3 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:leading-6 rounded-l-none">
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>

          <li>
            <div class="relative pb-4">
              <span class="absolute left-4 top-4 -ml-px h-full w-0.5 bg-gray-200" aria-hidden="true"></span>
              <div class="relative flex space-x-3">
                <div>
                  <span class="flex h-8 w-8 items-center justify-center rounded-full bg-gray-200 ring-8 ring-white">
                    <span class="text-lg">2</span>
                  </span>
                </div>
                <div class="flex min-w-0 flex-1 justify-between space-x-4">
                  <div class="text-base">
                    <h5 class="text-gray-800 text-lg font-medium">{{'text.enter_otp' | translate}}</h5>
                    <p class="text-gray-500">{{'text.enter_authentication_code' | translate}}</p>
                    <div class="mt-2">
                      <span [ngClass]="{'cursor-not-allowed pointer-events-none opacity-50': !isOtpSentToUser}">
                        <ng-otp-input [config]="{length:6, disableAutoFocus: true, allowNumbersOnly: true}"
                          [formCtrl]="otpFormControl"></ng-otp-input>
                      </span>

                      <div [hidden]="!isOtpSentToUser">
                        <div class="text-base primary-font text-secondary mt-2 mb-2"
                          *ngIf="transform(counter) !== '00:00'  && resendCodeCount < 5">
                          {{'resend.code.title' | translate}} in {{transform(counter)}}
                        </div>
                        <div class="text-base text-primary-500 primary-font cursor-pointer mt-2 mb-2"
                          *ngIf="transform(counter) === '00:00' && resendCodeCount < 5" (click)="sendSMSOtp()">
                          {{'resend.code.title' | translate}}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div class="flex justify-between border-gray-300 border-t zuper-dialog-footer">
      <div class="remove-btn-section">
        <button type="button" (click)="showRemoveAuthAlert('SMS')" *ngIf="check2FAForRemove('SMS')"
          class="px-6 flex items-center py-2 border shadow-sm text-white bg-red-600 text-base font-medium rounded-md btn-small">
          {{'text.remove' | translate}}
        </button>
      </div>

      <div class="add-btn-section">
        <button type="button" (click)="cancelSMSSetup()"
          class="ml-auto inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none mr-2">
          {{ 'cancel.text'| translate }}
        </button>

        <button type="button" (click)="sendSMSOtp()" [disabled]="disableUpdateButton" *ngIf="!isOtpSentToUser"
          [ngClass]="{'opacity-30 cursor-not-allowed submitBtn': disableUpdateButton}"
          class="inline-flex items-center px-4 py-2 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-primary hover:bg-primary-700 focus:outline-none">
          {{'login.auth.send.otp.text' | translate}}
        </button>

        <button type="button" (click)="verifyOtp('SMS')" *ngIf="isOtpSentToUser"
          class="inline-flex items-center px-4 py-2 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-primary hover:bg-primary-700 focus:outline-none">
          {{'login.auth.app.verify.text' | translate}}
        </button>
      </div>
    </div>
  </div>
</ng-template>

<!-- Email Setup Template -->
<ng-template #emailSetupTemplate>
  <div class="h-full profile-card-height">
    <div class="flex justify-between items-center border-b border-b-gray-300 zuper-dialog-header">
      <h2 class="text-xl font-semibold leading-6 text-gray-900 inline-flex items-center" id="slide-over-title">
        <button (click)="cancelEmailSetup()"
          class="h-10 w-10 p-2 mr-2 rounded-full hover:bg-gray-200">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" />
          </svg>
        </button>
        {{'text.email_setup' | translate}}
      </h2>
      <div class="flex items-center mr-1">
        <button mat-dialog-close
          class="rounded-full flex justify-center items-center hover:bg-gray-200 h-10 w-10 p-2 ml-2">
          <em class="ti ti-x text-xl font-bold"></em>
        </button>
      </div>
    </div>

    <div class="max-w-4xl px-5 py-2 card-content-height">
      <div class="flex min-w-0 flex-1 justify-between space-x-4">
        <div class="text-base">
          <p class="text-gray-500">{{'text.2fa.email_setup' | translate}}</p>
        </div>
      </div>

      <div class="flow-root mt-2">
        <ul role="list" class="my-4">
          <li>
            <div class="relative pb-8">
              <span class="absolute left-4 top-4 -ml-px h-full w-0.5 bg-gray-200" aria-hidden="true"></span>
              <div class="relative flex space-x-3">
                <div>
                  <span class="flex h-8 w-8 items-center justify-center rounded-full bg-gray-200 ring-8 ring-white">
                    <span class="text-lg">1</span>
                  </span>
                </div>
                <div class="flex flex-1 justify-between space-x-4">
                  <div class="text-base w-full">
                    <h5 class="text-gray-800 text-lg font-medium">{{'email' | translate}}</h5>
                    <p class="text-gray-500">{{'text.provide_email_adderess' | translate}}</p>
                    <div class="mt-2">
                      <span [ngClass]="{'cursor-not-allowed pointer-events-none opacity-50': isOtpSentToUser}">
                        <input type="email" name="email_input" id="email_input" placeholder="test@zuper.co"
                          autocomplete="off" [formControl]="emailFormControl" class="block w-full h-12 rounded-md border-0 px-3 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 
                          placeholder:text-gray-400 sm:leading-6">
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>

          <li>
            <div class="relative pb-4">
              <span class="absolute left-4 top-4 -ml-px h-full w-0.5 bg-gray-200" aria-hidden="true"></span>
              <div class="relative flex space-x-3">
                <div>
                  <span class="flex h-8 w-8 items-center justify-center rounded-full bg-gray-200 ring-8 ring-white">
                    <span class="text-lg">2</span>
                  </span>
                </div>
                <div class="flex min-w-0 flex-1 justify-between space-x-4">
                  <div class="text-base">
                    <h5 class="text-gray-800 text-lg font-medium">{{'text.enter_otp' | translate}}</h5>
                    <p class="text-gray-500">{{'text.enter_authentication_code' | translate}}</p>
                    <div class="mt-2">
                      <span [ngClass]="{'cursor-not-allowed pointer-events-none opacity-50': !isOtpSentToUser}">
                        <ng-otp-input [config]="{length:6, disableAutoFocus: true, allowNumbersOnly: true}"
                          [formCtrl]="otpFormControl"></ng-otp-input>
                      </span>

                      <div [hidden]="!isOtpSentToUser">
                        <div class="text-base primary-font text-secondary mt-2 mb-2"
                          *ngIf="transform(counter) !== '00:00'  && resendCodeCount < 5">
                          {{'resend.code.title' | translate}} in {{transform(counter)}}
                        </div>
                        <div class="text-base text-primary-500 primary-font cursor-pointer mt-2 mb-2"
                          *ngIf="transform(counter) === '00:00' && resendCodeCount < 5" (click)="sendEmailOtp()">
                          {{'resend.code.title' | translate}}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div class="flex justify-between border-gray-300 border-t zuper-dialog-footer">
      <div class="remove-btn-section">
        <button type="button" (click)="showRemoveAuthAlert('EMAIL')" *ngIf="check2FAForRemove('EMAIL')"
          class="px-6 flex items-center py-2 border shadow-sm text-white bg-red-600 text-base font-medium rounded-md btn-small">
          {{'text.remove' | translate}}
        </button>
      </div>

      <div class="add-btn-section">
        <button type="button" (click)="cancelEmailSetup();"
          class="ml-auto inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none mr-2">
          {{ 'cancel.text'| translate }}
        </button>

        <button type="button" (click)="sendEmailOtp()" [disabled]="disableUpdateButton" *ngIf="!isOtpSentToUser"
          [ngClass]="{'opacity-30 cursor-not-allowed submitBtn': disableUpdateButton}"
          class="inline-flex items-center px-4 py-2 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-primary hover:bg-primary-700 focus:outline-none">
          {{'login.auth.send.otp.text' | translate}}
        </button>

        <button type="button" (click)="verifyOtp('EMAIL')" *ngIf="isOtpSentToUser"
          class="inline-flex items-center px-4 py-2 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-primary hover:bg-primary-700 focus:outline-none">
          {{'login.auth.app.verify.text' | translate}}
        </button>
      </div>
    </div>
  </div>
</ng-template>

<!-- Recovery Codes Template -->
<ng-template #recoveryCodeTemplate>
  <div class="h-full profile-card-height">

    <div class="flex justify-between items-center border-b border-b-gray-300 zuper-dialog-header">
      <h2 class="text-xl font-semibold leading-6 text-gray-900 inline-flex items-center" id="slide-over-title">
        <button (click)="openProfileContainer('MFA Setup')" class="h-10 w-10 p-2 mr-2 rounded-full hover:bg-gray-200">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" />
          </svg>
        </button>
        {{'text.2fa.recovery_codes' | translate}}
      </h2>
      <div class="flex items-center mr-1">
        <button mat-dialog-close
          class="rounded-full flex justify-center items-center hover:bg-gray-200 h-10 w-10 p-2 ml-2">
          <em class="ti ti-x text-xl font-bold"></em>
        </button>
      </div>
    </div>

    <div class="mx-auto max-w-4xl px-5 my-1">
      <div class="flex min-w-0 flex-1 justify-between space-x-4">
        <div class="text-base">
          <p class="text-gray-500">{{'text.2fa.recovery_codes_usage_info' | translate}}. {{'text.2fa.recovery_code_details' | translate}}</p>
        </div>
      </div>

      <div class="w-full px-8 py-2 grid grid-cols-2 gap-4">
        <ng-container *ngFor="let code of recoveryCodes;">
          <span class="w-full h-9 me-2 px-2.5 pt-2 text-base font-semibold rounded bg-gray-100 text-gray-800
          dark:bg-gray-700 dark:text-gray-300 text-center">
            {{code?.recovery_code}}
          </span>
        </ng-container>
      </div>

      <div class="flex flex-auto flex-col justify-center items-center">
        <p class="text-gray-500 text-sm">
          {{'text.recovery_code_generated_at' | translate}} {{recoveryCodeDetails?.generatedDate | dateAgo}}.
        </p>
        <p class="text-gray-500 text-sm">
          {{recoveryCodeDetails?.usedCodes}} {{'text.recovery_code_used' | translate}},
          {{recoveryCodeDetails?.availableCodes}} {{'text.recovery_code_available' | translate}}.
        </p>

        <a class="text-primary-500 text-base hover:opacity-80 underline my-2" href="javascript:void(0);"
          (click)="generateRecoveryCodes()">
          {{'text.generate_new_code' | translate}}
        </a>
      </div>
    </div>

    <div class="flex border-gray-300 border-t zuper-dialog-footer">
      <button type="button" (click)="printRecoveryCodes()"
        class="ml-auto inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none mr-2">
        {{'text.print' | translate}}
      </button>
      <button type="button" (click)="downloadRecoveryCode()"
        class="inline-flex items-center px-4 py-2 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-primary hover:bg-primary-700 focus:outline-none">
        {{'text.download' | translate}}
      </button>
    </div>
  </div>
</ng-template>

<!-- Verify OTP Template -->
<ng-template #verifyOtpTemplate>
  <div class="h-full profile-card-height">

    <div class="flex justify-between items-center border-b border-b-gray-300 zuper-dialog-header">
      <h2 class="text-xl font-semibold leading-6 text-gray-900 inline-flex items-center" id="slide-over-title">
        <button class="h-10 w-10 p-2 mr-2 rounded-full hover:bg-gray-200" (click)="cancelVerifyOTP()">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" />
          </svg>
        </button>
        {{'text.verify_2fa_setup' | translate}}
      </h2>
      <div class="flex items-center mr-1">
        <button mat-dialog-close
          class="rounded-full flex justify-center items-center hover:bg-gray-200 h-10 w-10 p-2 ml-2">
          <em class="ti ti-x text-xl font-bold"></em>
        </button>
      </div>
    </div>

    <div class="mx-auto max-w-4xl px-5 mt-3 card-content-height">
      <div class="flex min-w-0 flex-1 justify-between space-x-4">
        <div class="text-base">
          <p class="text-md font-semibold leading-6 text-gray-900">{{'text.verify_2fa_setup_info' | translate}}</p>
          <p class="text-gray-500 mt-2">{{retryOtpResponse?.message}}. {{'text.check_inbox' | translate}}!</p>
        </div>
      </div>

      <div class="flex min-w-0 flex-1 justify-between space-x-4 py-4">
        <div class="text-base">
          <label for="otp" class="block text-base font-normal leading-8 text-gray-800">
            {{'text.enter_authentication_code' | translate}} <span class="text-red-500"> *</span>
          </label>

          <div class="mt-2">
            <ng-otp-input [config]="{length:6, disableAutoFocus: true, allowNumbersOnly: true}"
              [formCtrl]="otpFormControl"></ng-otp-input>

            <ng-container *ngIf="isOtpSentToUser">
              <div class="text-base primary-font text-secondary mt-2 mb-2"
                *ngIf="transform(counter) !== '00:00'  && resendCodeCount < 5">
                {{'resend.code.title' | translate}} in {{transform(counter)}}
              </div>
              <div class="text-base text-primary-500 primary-font cursor-pointer mt-2 mb-2"
                *ngIf="transform(counter) === '00:00' && resendCodeCount < 5"
                (click)="retryOtpVerification(selected2faMode)">
                {{'resend.code.title' | translate}}
              </div>
            </ng-container>

          </div>
        </div>
      </div>
    </div>

    <div class="flex justify-between border-gray-300 border-t zuper-dialog-footer">
      <div class="remove-btn-section">
        <button type="button" (click)="showRemoveAuthAlert(selected2faMode, true)"
          class="px-6 flex items-center py-2 border shadow-sm text-white bg-red-600 text-base font-medium rounded-md btn-small">
          {{'text.remove' | translate}}
        </button>
      </div>
    
      <div class="verify-btn-section">
        <button type="button" (click)="cancelVerifyOTP()"
          class="ml-auto inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none mr-2">
          {{ 'cancel.text'| translate }}
        </button>
        <button type="button" (click)="verifyOtp(selected2faMode)"
          class="inline-flex items-center px-4 py-2 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-primary hover:bg-primary-700 focus:outline-none">
          {{'login.auth.app.verify.text' | translate}}
        </button>
      </div>
    </div>

  </div>
</ng-template>